import React from "react";
import cn from "classnames";
import { CheckIcon } from "../../icons";
import { useFilterContext } from "../head-bar/filter-context";
import { observer } from "mobx-react-lite";

export const SortFilter = observer(({ setOpen }) => {
  const { filterParams, state, setState } = useFilterContext();
  const onClick = (item) => {
    setState({ sort: item.value });
    setOpen("");
  };
  return (
    <div className="head-filter__sort">
      {filterParams.order_by.map((item) => {
        return (
          <div
            className={cn("filter__sort-item", {
              "filter__sort-item--active": state.sort === item.value,
            })}
            key={item.value}
            onClick={() => onClick(item)}
          >
            <div className="filter__sort-label">{item.name}</div>
            {state.sort === item.value && <CheckIcon></CheckIcon>}
          </div>
        );
      })}
    </div>
  );
});
